export default __webpack_public_path__ + "static/media/logo.02e65e1d.svg";